export default function({ store, redirect }) {
  if(!store.getters['auth/isLogin']){
    console.log("in logout")
    return redirect('/checkin/')
  }
}
